export default "__VITE_ASSET__vZclUDYV__"